import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-fraud',
  imports: [CommonModule, RouterLink],
  templateUrl: './fraud.component.html',
  styleUrl: './fraud.component.scss',
})
export class FraudComponent {
  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.setMetaData();
  }

  private setMetaData(): void {
    const title = 'Fraud Awareness | Sell Your Tesla | Only Used Tesla';
    const description = 'Fraud Awareness | Only Used Tesla | A Place Exclusively Dedicated To Buying And Selling Used Teslas. Learn how to identify fraud and protect yourself when buying or selling a Tesla.';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png'; // You can change this image if needed
    const url = 'https://onlyusedtesla.com/fraud-awareness';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }
}
